import React from 'react'
import styled from 'styled-components'
import { Input, Modal, Select } from 'antd'

const PROVIDERS = [
  { value: 'les_echos', label: 'Les Echos' },
  { value: 'internal', label: 'Manuel' },
] as const

interface Props {
  open: boolean
  confirmLoading: boolean
  provider: string
  onProviderChange: (value: string) => void
  providerReference: string
  onProviderReferenceChange: (value: string) => void
  onOk: () => void
  onCancel: () => void
}

const CreateLegalNoticeModal = ({
  open,
  confirmLoading,
  provider,
  onProviderChange,
  providerReference,
  onProviderReferenceChange,
  onOk,
  onCancel,
}: Props): JSX.Element => (
  <Modal
    title="Créer une legal notice"
    open={open}
    onCancel={onCancel}
    onOk={onOk}
    confirmLoading={confirmLoading}
    okText="Créer"
    cancelText="Annuler"
  >
    <ModalBody>
      <label>Provider</label>
      <Select
        value={provider}
        onChange={onProviderChange}
        style={{ width: '100%' }}
        options={PROVIDERS.map(p => ({ value: p.value, label: p.label }))}
      />
      {provider !== 'internal' && (
        <>
          <label>Référence provider (optionnel)</label>
          <Input
            value={providerReference}
            onChange={e => onProviderReferenceChange(e.target.value)}
            placeholder="Ex: 12345"
          />
        </>
      )}
    </ModalBody>
  </Modal>
)

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 0;

  label {
    font-weight: 600;
    font-size: 13px;
  }
`

export default CreateLegalNoticeModal
